(() => {
  const placeReviews = () => {
    const section = document.getElementById('basic-product-reviews');
    if (!section) return;
    const main = section.closest('main');
    if (!main) return;
    const roseTitle = main.querySelector('#rose-product-title');
    const rating = main.querySelector('.basic-product-rating');
    if (roseTitle && rating) roseTitle.after(rating);
    const previous = main.querySelector('.pdp-voices');
    if (previous) previous.before(section);
    else {
      const details = main.querySelector('.pdp-details, .rose-details');
      if (details) details.before(section);
    }
    main.querySelectorAll('.pdp-rating').forEach(element => element.remove());
    const connectReviewLinks = () => {
      if (!section.querySelector('#klaviyo-product-reviews-wrapper')) return false;
      const stars = rating?.querySelector('.kl_reviews__star_rating_widget');
      if (stars && stars.tagName !== 'A') {
        stars.setAttribute('role', 'link');
        stars.setAttribute('tabindex', '0');
      }
      main.querySelectorAll('a[href="#voices-title"]').forEach(link => {
        link.href = '#basic-product-reviews';
      });
      return true;
    };
    const sourceLabels = {
      recommend: 'à quel point recommanderais-tu ce produit à ton entourage ?',
      efficacy: 'comment juges-tu son efficacité ?',
      skin: 'quel est ton type de peau ?',
      recommend_low: 'seulement à mes ennemis',
      recommend_high: "à tous ceux que j'aime",
      efficacy_low: 'je pue', efficacy_high: 'je sens la rose',
      dry: 'sèche', combination: 'mixte', oily: 'grasse', sensitive: 'sensible', normal: 'normale'
    };
    const labelData = section.querySelector('[data-review-custom-labels]');
    const translatedLabels = labelData ? JSON.parse(labelData.textContent) : {};
    Object.keys(translatedLabels).forEach(key => {
      translatedLabels[key] = translatedLabels[key].replaceAll('&#39;', "'").replaceAll('&quot;', '"').replaceAll('&amp;', '&');
    });
    const translations = Object.entries(sourceLabels).filter(([key, source]) => translatedLabels[key] && translatedLabels[key] !== source);
    const translateCustomQuestions = () => {
      const wrapper = section.querySelector('#klaviyo-product-reviews-wrapper');
      if (!wrapper || !translations.length) return;
      // Only translate structured questionnaire labels. Customer comments remain untouched.
      wrapper.querySelectorAll('[class*="custom_question"], [class*="custom_question"] span').forEach(element => {
        element.childNodes.forEach(node => {
          if (node.nodeType !== Node.TEXT_NODE) return;
          const original = node.textContent;
          const value = original.trim();
          const match = translations.find(([, source]) => value === source || value.startsWith(source + ' ('));
          if (match) node.textContent = original.replace(match[1], translatedLabels[match[0]]);
        });
      });
      wrapper.querySelectorAll('[class*="custom_question"] [role="img"][aria-label]').forEach(element => {
        const original = element.getAttribute('aria-label');
        const translated = translations.reduce((label, [key, source]) => label.replaceAll(source, translatedLabels[key]), original);
        if (translated !== original) element.setAttribute('aria-label', translated);
      });
    };
    if (rating) {
      const openReviews = event => {
        if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;
        if (!event.target.closest('.kl_reviews__star_rating_widget')) return;
        if (!section.querySelector('#klaviyo-product-reviews-wrapper')) return;
        event.preventDefault();
        section.querySelector('#klaviyo-reviews-all').scrollIntoView({
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start'
        });
      };
      rating.addEventListener('click', openReviews);
      rating.addEventListener('keydown', openReviews);
    }
    connectReviewLinks();
    translateCustomQuestions();
    const observer = new MutationObserver(() => {
      connectReviewLinks();
      translateCustomQuestions();
    });
    const reviewWidget = section.querySelector('#klaviyo-reviews-all');
    if (reviewWidget) observer.observe(reviewWidget, { childList: true, characterData: true, subtree: true });
    if (rating) observer.observe(rating, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', placeReviews, { once: true });
  else placeReviews();
})();
